<template>
  <VdPage class="sandbox-preview-page" with-background :title="title" show-back-arrow :loading="loading" @back="onBack">
    <ConfigVisualizer :config-data="configData" />
  </VdPage>
</template>

<script lang="ts">
import { VdPage } from "@voodoo.io/voodoo-ui";
import { defineComponent, computed } from "vue";
import { useRouter } from "vue-router";

import ConfigVisualizer from "@/modules/Simulation/components/ConfigVisualizer.vue";
import { useSandboxDisplayPageQuery } from "@/graphql";
import links from "@/router/links";

export default defineComponent({
  name: "SandboxDisplayPage",

  components: {
    ConfigVisualizer,
    VdPage,
  },

  props: {
    gameId: {
      type: String,
      required: true,
    },
    versionId: {
      type: String,
      required: true,
    },
    sandboxId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const router = useRouter();

    const { result, loading } = useSandboxDisplayPageQuery({
      gameId: props.gameId,
      sandboxId: props.sandboxId,
    });

    const sandbox = computed(() => result.value?.game?.sandbox);

    const title = computed(() => sandbox.value?.name ?? "...");

    const configData = computed(() => sandbox.value?.rawClasses ?? []);

    const onBack = () => {
      router.push({
        name: links.games.sandboxes.list,
        params: { gameId: props.gameId, versionId: props.versionId },
      });
    };

    return {
      sandbox,
      title,
      configData,
      loading,
      onBack,
    };
  },
});
</script>
